/* eslint-disable complexity */
import { trackPageInteraction } from "asos-contentweb-analytics-middleware";
import { getViewportDimensions } from "../helpers";
import getUserLoginStatus from "./getUserLoginStatus";
import affIdCheck from "./checkForAffiliateId";
import sdkProvider from "../helpers/sdk-provider";
import { getPremierAnalytics } from "./premierAnalyticsValues";

export default async (premierPrice, freeTrial) => {
  const {
    platform = "",
    storeId = "",
    browseCountry = "",
    browseCurrency = "",
  } = window.asos.webContext.getWebContext();
  const s = window && window.s;
  const identity = await sdkProvider("identity");
  const isAuthenticated = await identity.customer.isAuthenticated();
  const isRecognised = (await identity.customer.isRecognised?.()) || false;
  const customerId = await identity.customer.customerId();
  const pageTitle = "premier";
  const server = `${platform} ${storeId.toLowerCase()}`;
  const commonProps = {
    pageName: `${server}|${pageTitle}`,
    products: `;#1;1;${premierPrice}`,
    prop1: `discover|${pageTitle}`,
    prop2: pageTitle,
    prop3: pageTitle,
    prop8: `discover|${pageTitle}`, // middleware
    prop6:
      s.getQueryParamValue("CTAref", true) !== ""
        ? s.getQueryParamValue("CTAref", true).toLowerCase()
        : "",
    prop5: s.getCustomTimeDate().toString().toLowerCase(), // middleware
    prop10: `discover|${s.getPreviousValue(s.pageName, "gpv_p10")}`, // middleware
    prop11: encodeURI(window.location.href.replace(/%20/gi, "+")), // middleware
    prop25: browseCountry,
    prop31: getUserLoginStatus({ isAuthenticated, isRecognised }),
    eVar1: s.getVisitNum(), // middleware
    eVar6: `${s
      .getPreviousValue(s.pageName, "gpv_p10", "")
      .toLowerCase()}|${pageTitle}`, // map from the last page we came from
    eVar10: customerId,
    eVar15: `${pageTitle}`,
    eVar12: affIdCheck(), // middleware
    eVar17: s.getNewRepeat(365), // middleware
    eVar19: getViewportDimensions(),
    eVar28: encodeURI(window.location.href.replace(/%20/gi, "+")),
    eVar47: s.getPreviousValue(s.eVar6, "gpv_e47", ""),

    eVar60: `${server}|${pageTitle}`,
    eVar61: `${server}|${pageTitle}`,
    eVar33: browseCurrency, // middleware
    eVar112: browseCountry,
    eVar113: browseCurrency,
    eVar106: `premier${freeTrial ? " free trial" : ""}|button|click`,
    eVar141: await getPremierAnalytics(),
    channel: pageTitle,
  };

  const buttonClick = {
    "add-to-bag": {
      eventName: "Premier Add to Bag",
      linkType: "o",
      linkVars: {
        ...commonProps,
      },
      eventVars: {
        event150: "1",
        event151: premierPrice,
      },
    },
  };

  if (freeTrial) {
    buttonClick["add-to-bag"].eventVars.event172 = "event172";
  }

  // eslint-disable-next-line max-len
  trackPageInteraction(buttonClick["add-to-bag"]);
};
